export default "__VITE_ASSET__DMU79del__"